<template>
<gcmcn-modal
    :show="toggled"
    :closeOnClick="false"
    @close="close"
>
    <div class="resolve-mismatch-dialog">
        <div class="resolve-modal-title">Resolve Mismatch</div>
        <div v-if="mismatch">
            <div v-if="step === 1">
                <div class="gcmcn-form-input">
                    <div class="gcmcn-form-label modal-label">Select an entity</div>
                    <el-select v-model="selectedEntityUid" placeholder="Select an entity" popper-class="gcmcn-popper">
                        <el-option v-for="item in entities"
                            :key="item.uid"
                            :label="item.display_name"
                            :value="item.uid">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div v-if="step === 2">
                <ns-loader
                    ref="eventLoader"
                    :key="selectedEntityUid"
                    :toLoad="toLoadEvent"
                    :custom-scope="entityScope"
                    @dataFetched="onEventFetched"
                >
                    <ns-loader-spinner slot="loader"></ns-loader-spinner>
                    <div slot="content">
                        <div class="gcmcn-form-input">
                            <div class="gcmcn-form-label modal-label">Select an event</div>
                            <el-select v-model="selectedEventUid" placeholder="Select an event" popper-class="gcmcn-popper">
                                <el-option v-for="item in events"
                                    :key="item.uid"
                                    :label="item.name"
                                    :value="item.uid">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </ns-loader>
            </div>
            <div v-if="step === 3">
                <ns-loader
                    ref="feedLoader"
                    :key="selectedEventUid"
                    :toLoad="toLoadFeed"
                    :custom-scope="entityScope"
                    @dataFetched="onFeedFetched"
                >
                    <ns-loader-spinner slot="loader"></ns-loader-spinner>
                    <div slot="content">
                        <div class="gcmcn-form-input">

                            <div class="gcmcn-form-label modal-label">Associate to an existing feed</div>

                            <el-select :key="feeds.length" v-model="selectedFeedUid" placeholder="Select a feed" :disabled="createNewFeed" popper-class="gcmcn-popper">
                                <el-option v-for="item in feeds"
                                    :key="item.uid"
                                    :label="item.display_name"
                                    :value="item.uid">
                                </el-option>
                            </el-select>
                            <div class="new-feed-section gcmcn-form-label modal-label">
                                <span style="margin-right: 10px">OR</span><el-checkbox v-model="createNewFeed" label="Create new feed"></el-checkbox>
                            </div>
                            <el-input v-model="newFeedName" placeholder="Enter a feed name" :disabled="!createNewFeed"></el-input>
                        </div>
                    </div>
                </ns-loader>
            </div>
        </div>
        <span slot="footer">
            <el-button type="text" @click="close">Cancel</el-button>
            <el-button type="primary" :disabled="disableNextButton" @click="step < 3 ? next() : resolve()">{{step < 3 ? 'Next' : 'Resolve'}}</el-button>
        </span>
    </div>
</gcmcn-modal>
</template>

<script>

import {mapGetters} from 'vuex';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import {GcmcnModal} from 'gcmcn-common'

export default {

    components: {
        NsLoader,
        NsLoaderSpinner,
        GcmcnModal
    },

    props: {

    },

    data: function(){
        return {
            mismatch: null,
            selectedEntityUid: '',
            selectedEventUid: '',
            selectedFeedUid: '',
            createNewFeed: false,
            newFeedName: '',
            toggled: false,
            step: 1,
            events: [],
            feeds: []
        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'entities'
        ]),
        feedsByUid() {
            return this.feeds.find(feed => feed.uid === this.selectedFeedUid);
        },
        toLoadEvent() {
            return [
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false
                    }
                }
            ]
        },
        toLoadFeed() {
            return [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        archived: false,
                        confirmed: false,
                        event_uid: this.selectedEventUid,
                        status: 'AVAILABLE'
                    }
                }
            ]
        },
        entityScope (){
            return { 'X-Entity-Uid': this.selectedEntityUid};
        },
        disableNextButton() {
            if (this.step === 1) {
                return !this.selectedEntityUid;
            } else if (this.step === 2) {
                return !this.selectedEventUid;
            } else {
                if (this.createNewFeed) {
                    return this.newFeedName === '';
                } else {
                    return !this.selectedFeedUid;
                }
            }
        }
    },

    mounted: function(){

    },

    methods: {
        onEventFetched(res) {
            this.$set(this, 'events', res.events);
        },
        onFeedFetched(res) {
            this.$set(this, 'feeds', res.feeds);
        },
        close() {
            this.toggled = false;
            this.$set(this, 'mismatch', null);
            this.selectedEntityUid = '';
            this.selectedEventUid = '';
            this.selectedFeedUid = '';
            this.createNewFeed = false;
            this.newFeedName = '';
            this.step = 1;
        },
        open(mismatch) {
            this.$set(this, 'mismatch', mismatch);
            this.selectedEntityUid = mismatch.scopes ? mismatch.scopes.entity_uid : '';
            this.selectedEventUid = mismatch.event_uid;
            this.selectedFeedUid = mismatch.feed_uid;
            this.toggled = true;
        },
        next() {
            this.step++;
        },
        patchMismatch() {
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.mismatch.uid,
                    url: this.mismatch.url,
                    resolved: true,
                    event_uid: this.selectedEventUid,
                    feed_uid: this.selectedFeedUid,
                },
                model: 'bookingMismatches',
                scopes: {'X-Entity-Uid': this.selectedEntityUid}
            }).then(() => {
                this.$message.success({
                    message: `Mismatch resolved`
                });
            }).catch(err => {
                this.$message.error({
                    message: `Mismatch couldn't be resolved`
                });
            })
        },
        resolve() {
            if (this.createNewFeed) {
                this.$store.dispatch('createItem', {
                    item: {
                        confirmed: true,
                        name: this.newFeedName,
                        display_name: this.newFeedName,
                        event_uid: this.selectedEventUid,
                        start_date: this.mismatch.start_date,
                        confirmed_start_date: this.mismatch.start_date,
                        confirmed_end_date: this.mismatch.end_date,
                        booking_key: this.mismatch.booking_key,
                        end_date: this.mismatch.end_date,
                        video_source_uid: this.mismatch.video_source_uid,
                        can_admin_users: [this.$store.getters.currentUser.uid]
                    },
                    model: 'feeds',
                    url: this.$store.state.api.meta.listModels.feeds.url,
                    scopes: {'X-Entity-Uid': this.selectedEntityUid}
                }).then((res) => {
                    this.selectedFeedUid = res.uid;
                    this.patchMismatch();
                    this.$message.success({
                        message: `New feed ${this.newFeedName} successfully created`
                    });
                    this.close();
                    this.$router.push({
                        name: 'feeds',
                        params: { feedUid: res.uid }
                    });
                }).catch(err => {
                    console.error(err);
                })
            } else {
                this.$store.dispatch('patchItem', {
                    item: {
                        uid: this.selectedFeedUid,
                        url: this.feedsByUid.url,
                        confirmed: true,
                        event_uid: this.selectedEventUid,
                        confirmed_start_date: this.mismatch.start_date,
                        confirmed_end_date: this.mismatch.end_date,
                        booking_key: this.mismatch.booking_key,
                        video_source_uid: this.mismatch.video_source_uid,
                    },
                    model: 'feeds',
                    scopes: {'X-Entity-Uid': this.selectedEntityUid}
                }).then((res) => {
                    this.patchMismatch();
                    this.$message.success({
                        message: `Feed correctly fixed`
                    });
                    this.close();
                    this.$router.push({
                        name: 'feeds',
                        params: { feedUid: res.uid }
                    });
                }).catch(err => {
                    this.$message.error({
                        message: `Feed couldn't be fixed`
                    });
                })
            }
        },
    },
};
</script>

<style lang="scss">
.resolve-mismatch-dialog {
    .resolve-modal-title {
        margin-bottom: 10px;
        color: #BBB;
    }
    .modal-label {
        margin-bottom: 10px;
    }
    .new-feed-section {
        margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Mismatches/resolveModal.vue